<template>
  <div class="resp-in-progress_root">
    <div class="container">
      <h2 class="resp-in-progress_title">Заявка на отклик</h2>
    </div>
    <div class="bids-list container">
      <el-table
        v-if="isLoadingResp || !generatedList.length"
        v-loading="isLoadingResp"
        :data="generatedList"
        :class="generatedList.length ? 'table-class' : 'table-class-empty'"
      />
      <section v-else class="middle-section">
        <el-row :gutter="20" style="text-align: center; margin: 15px 0 10px">
          <el-col :span="2">Дата</el-col>
          <el-col :span="4">ФИО</el-col>
          <el-col :span="3">Авто</el-col>
          <el-col :span="5">Перевозчик</el-col>
          <el-col :span="3">Цена</el-col>
          <el-col :span="2">Телефон</el-col>
          <el-col :span="2">Статус</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <transition-group name="slide-fade" tag="div">
              <div
                v-for="response in generatedList"
                :key="response.id"
                :ref="'response' + response.id"
                :class="[
                  'check-list',
                  'mod-default',
                  { 'active-response': activeResponseStyle === response.id },
                  { 'overdue-response': getHighlightRequestId === response.id },
                ]"
              >
                <div>
                  <el-col class="auto-list_col" :span="2">
                    <column-date :show-status="false" :response="response" />
                  </el-col>

                  <el-col class="auto-list_col" :span="4">
                    <column-short-fio
                      :response="response"
                      :allow-active="checkAllowActive(response)"
                      class="mod-pointered"
                      @open="setOpen(response, 'driverDialog')"
                    />
                  </el-col>
                  <el-col class="auto-list_col" :span="3">
                    <column-state-numbers
                      :response-auto="response.automobile_plate"
                      :allow-active="checkAllowActive(response)"
                      class="mod-pointered"
                      @open="setOpen(response, 'automobileDialog')"
                    />
                  </el-col>

                  <el-col class="auto-list_col" :span="5">
                    <column-carrier
                      :response="response"
                      :allow-active="checkAllowActive(response)"
                      @openModalPhone="setOpen(response, 'phoneDialog')"
                      @openModalContragent="
                        setOpen(response, 'contragentDialog')
                      "
                    />
                  </el-col>

                  <el-col class="auto-list_col" :span="3">
                    <column-price :response="response" :type="bid.type_code" />
                  </el-col>

                  <el-col class="auto-list_col" :span="2">
                    <phone-in-progress :response="response" />
                  </el-col>

                  <el-col class="auto-list_col" :span="2">
                    <status-in-progress
                      :response-status="response.request_status"
                      :response-handle-date="response.request_status_date"
                      :response-handle-name="response.request_status_set_by"
                    />
                  </el-col>
                </div>

                <el-col
                  v-if="checkAllowActive(response)"
                  class="auto-list_col"
                  :span="2"
                >
                  <column-action
                    :response="response"
                    :active-action-accept="disableActionAccept(response)"
                    @accepted="handleAccept"
                  />
                </el-col>
              </div>
            </transition-group>
          </el-col>
        </el-row>
      </section>
    </div>
    <template v-if="generatedList.length">
      <driver-modal-in-progress
        :visible="driverDialog"
        :response="getActiveResponse()"
        @close="onClose('driverDialog')"
      />
      <phone-modal-in-progress
        :visible="phoneDialog"
        :response="getActiveResponse()"
        @close="onClose('phoneDialog')"
      />
      <automobile-modal-in-progress
        :visible="automobileDialog"
        :response="getActiveResponse()"
        @close="onClose('automobileDialog')"
      />
      <contragent-modal-in-progress
        :visible="contragentDialog"
        :response="getActiveResponse()"
        @close="onClose('contragentDialog')"
      />
    </template>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { SET_SELECTED_RESPONSE } from '@/store/actions/loadDay'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ColumnAction from '@/views/LoadDay/Components/Responses/Columns/ActionInProgress'
import ColumnCarrier from '@/views/LoadDay/Components/Responses/Columns/CarrierInProgress'
import ColumnDate from '@/views/LoadDay/Components/Responses/Columns/DateInProgress'
import ColumnPrice from '@/views/LoadDay/Components/Responses/Columns/PriceInProgress'
import ColumnShortFio from '@/views/LoadDay/Components/Responses/Columns/ShortFIOinProgress'
import ColumnStateNumbers from '@/views/LoadDay/Components/Responses/Columns/StateNumbersInProgress'

import AutomobileModalInProgress from '@/views/LoadDay/Modals/AutomobileModalInProgress'
import ContragentModalInProgress from '@/views/LoadDay/Modals/ContragentModalInProgress'
import DriverModalInProgress from '@/views/LoadDay/Modals/DriverModalInProgress'
import PhoneInProgress from '@/views/LoadDay/Components/Responses/Columns/PhoneInProgress'
import PhoneModalInProgress from '@/views/LoadDay/Modals/PhoneModalInProgress'
import StatusInProgress from '@/views/LoadDay/Components/Responses/Columns/StatusInProgress'
const DocApi = RepositoryFactory.get('document')
const TtnApi = RepositoryFactory.get('ttn')

export default {
  name: 'ResponsesInProgress',
  components: {
    ContragentModalInProgress,
    DriverModalInProgress,
    PhoneModalInProgress,
    AutomobileModalInProgress,
    StatusInProgress,
    PhoneInProgress,
    ColumnDate,
    ColumnShortFio,
    ColumnStateNumbers,
    ColumnCarrier,
    ColumnPrice,
    ColumnAction,
  },
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      contragentDialog: false,
      driverDialog: false,
      phoneDialog: false,
      automobileDialog: false,
      activeResponse: {},
      loader: false,
      ttnLoader: false,
      responseTtnData: [],
      activeResponseStyle: null,
    }
  },
  computed: {
    ...mapGetters({
      getLoading: 'loadDay/getLoading',
      docTypes: 'documentTypes/getDocumentTypes',
      getHighlightRequestId: 'loadDay/getHighlightRequestId',
    }),
    isLoadingResp() {
      return this.getLoading('RespRequest')
    },
    generatedList() {
      return this.list.map(item => {
        const ttnData = this.responseTtnData.filter(
          ttn => ttn.response_id === item.id,
        )

        return {
          ...item,
          ttnData,
          weightStatus: this.getWeightStateClass(item),
          ttnStatus: this.getTtnStateClass(ttnData),
        }
      })
    },
  },
  watch: {
    list(newVal) {
      if (newVal?.length) {
        this.getResponsesTtn(newVal)
      }
    },
    generatedList() {
      const overdueElem = this.$refs['response' + this.getHighlightRequestId]

      if (overdueElem) {
        overdueElem[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
  },
  mounted() {
    const { response_id } = this.$route.query

    if (response_id) {
      this.activeResponseStyle = Number(response_id)
    }
    const overdueElem = this.$refs['response' + this.getHighlightRequestId]

    if (overdueElem) {
      this.$nextTick(() =>
        overdueElem[0].scrollIntoView({ behavior: 'smooth', block: 'center' }),
      )
    }
  },
  beforeDestroy() {
    this.setHighlightRequestId(0)
  },
  methods: {
    ...mapActions({
      fetchResponsesInDay: 'loadDay/fetchResponsesInDay',
      setSelectedResponse: `loadDay/${SET_SELECTED_RESPONSE}`,
    }),
    ...mapMutations({
      updateBid: 'loadDay/updateBid',
      setHighlightRequestId: 'loadDay/setHighlightRequestId',
    }),
    checkAllowActive(response) {
      if (
        response?.request_status === 'declined' ||
        response?.request_status === 'accepted'
      ) {
        return false
      }

      return true
    },
    disableActionAccept(response) {
      return (
        response?.automobile_id === null ||
        response?.automobile_id === undefined ||
        response?.driver_id === null ||
        response?.driver_id === undefined
      )
    },
    setOpen(resp, key) {
      this.activeResponseStyle = resp.id
      this.activeResponse = resp
      this[key] = true
      this.setHighlightRequestId(0)
    },
    onClose(key) {
      this[key] = false
      this.activeResponse = {}
    },
    getWeightStateClass(response) {
      const def = response.unacceptable_deficiency

      if (def === 0) {
        return 'success'
      }
      if (def > 0) {
        return 'danger'
      }

      return ''
    },
    getTtnStateClass(ttnData) {
      if (!ttnData.length) {
        return 'danger'
      }
      if (
        ttnData.some(ttn => !ttn.brutto_fact || !ttn.img_url || !ttn.brutto_ttn)
      ) {
        return 'warning'
      }

      return 'success'
    },

    async fetchGetAct(response) {
      const documentType = this.docTypes.find(t => t.code === 'works_act')

      try {
        const { data } = await DocApi.getDocument(
          'responses',
          response.id,
          documentType.code,
        )
      } catch (error) {
        this.errHandler(error)
      } finally {
        this.loader = false
      }
    },
    getResponsesTtn(responses) {
      const TtnListPromise = responses.map(response =>
        TtnApi.getList(response.id),
      )

      this.ttnLoader = true
      Promise.all(TtnListPromise)
        .then(resp => {
          const { data: allTtns } = resp.reduce(
            (a, b) => ({ data: [...a.data, ...b.data] }),
            { data: [] },
          )

          this.responseTtnData = allTtns
        })
        .catch(e => this.errHandler(e))
        .finally(() => (this.ttnLoader = false))
    },

    getActiveResponse() {
      return this.generatedList.filter(r => r.id === this.activeResponse?.id)[0]
    },

    handleAccept() {
      this.setHighlightRequestId(0)
      this.$emit('accept')
    },
  },
}
</script>

<style lang="sass">
.resp-in-progress
  &_root
    margin-bottom: 32px
  &_title
    color: #409EFF
    font-weight: 600
    font-size: 16px
    text-transform: uppercase
    margin-top: 30px
    margin-bottom: 30px
    padding: 0

.bids-list .middle-section .check-list
  margin: 0 0 20px
.bids-list .middle-section .check-list.mod-default
  cursor: default

.bids-list
  .table-class
    width: 100%
    height: 40vh
    margin-top: 20px
  .table-class-empty
    width: 100%
    height: 5vh
    margin-top: 20px
  .middle-section
    .active-response
      border: 1px solid #3498DB
    .overdue-response
      border: 2px solid red
    .check-list
      margin: 0 0 20px
      background: #fff
      align-items: center
      height: 100px
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
      .auto-list_col
        height: 100px

        .mod-pointered
          cursor: pointer

        .auto-list_col_centered
          height: 100%
          display: grid
          align-items: center
          text-align: center

      .check-list-time
        text-align: center

      .check-list-phone
        font-size: 16px
        line-height: 21px

      .check-list-autos
        font-size: 14px
        line-height: 21px

      .check-list-action
        img
          margin: 10px

      .check-list-person
        p
          margin: 5px
          font-size: 16px
          line-height: 22px

      .grey
        color: #98A9BC

.mr25
  margin-right: 25px

.flex__center
  display: flex
  justify-content: center
  align-items: center
</style>
